import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISubmissionState } from '../types/youths';

const initialState: ISubmissionState = {
    isOpen: false
};

export const submissionDialogState = createSlice({
    name: 'submissionDialog',
    initialState,
    reducers: {
        updateSubmissionDialog: (state, action: PayloadAction<ISubmissionState>) => {
            if (action.payload) {
                state.isOpen = action.payload.isOpen;
            } else {
                return initialState;

            }
        },
    },
});

export const { updateSubmissionDialog } = submissionDialogState.actions;

export default submissionDialogState.reducer;